import { fromPromise } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { t } from '#i18n';

const renderErrorToast = (toast, { title, description }) => toast({
  title,
  description,
  status: 'error',
  duration: 5000,
  isClosable: true,
});

// eslint-disable-next-line consistent-return
export const handleError = (signOut, toast, { networkError }) => {
  if (networkError) {
    if (networkError.statusCode === 401) {
      return fromPromise(
        signOut().then(() => renderErrorToast(toast, {
          title: t('alerts.sessionExpired.title'),
          description: t('alerts.sessionExpired.message'),
        })),
      );
    }

    renderErrorToast(toast, {
      title: t('alerts.unexpectedError.title'),
      description: t('alerts.unexpectedError.message'),
    });
  }
};

export const createErrorLink = (signOut, toast) => onError(
  (errorResponse) => handleError(signOut, toast, errorResponse),
);
